<div class="datetime-row" [class.is-disabled]="internal.disabled">
  <mat-form-field appearance="outline" class="date-part">
    <mat-label>{{ dateLabel }}</mat-label>
    <input matInput
           [matDatepicker]="picker"
           [formControl]="dateControl"
           [required]="required"
           [min]="min"
           [max]="max"
           [placeholder]="placeholder"
           (blur)="onTouched()">
    <mat-datepicker-toggle matIconSuffix [for]="picker" [disabled]="internal.disabled"></mat-datepicker-toggle>
    <mat-datepicker #picker [disabled]="internal.disabled"></mat-datepicker>
    @if (showDateError()) {
      <mat-error>{{ currentDateErrorMessage() }}</mat-error>
    }
  </mat-form-field>

  <mat-form-field appearance="outline" class="time-part">
    <mat-label>{{ timeLabel }}</mat-label>
    <input matInput
           type="time"
           [formControl]="timeControl"
           [required]="required"
           [step]="step"
           (blur)="onTouched()">
    @if (showTimeError()) {
      <mat-error>{{ timeErrorMessage }}</mat-error>
    }
  </mat-form-field>
</div>
